import Accordion from "accordion-js";
import "accordion-js/dist/accordion.min.css";

$(function () {
	new Accordion(".accordion-container");
});